var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wordCloud__tagBall",style:({ width: '210px', height: '120px' }),on:{"mouseenter":_vm.stop,"mouseleave":_vm.start}},_vm._l((_vm.data),function(item,index){return _c('span',{key:index,staticClass:"wordCloud__tag",style:({
        color: _vm.color[index % _vm.color.length],
        ..._vm.contentEle[index].style,
      }),attrs:{"title":item.name + ' : ' + item.value},on:{"click":function($event){return _vm.wordClick(item)}}},[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }